import { productLinkingState } from '@diagram/state/product-linking';

import { useSnapshot } from 'hooks/use-safe-snapshot';

const useProductLinking = () => useSnapshot(productLinkingState);

export { useProductLinking };
